import { Component } from 'react'
import { ThemeProvider } from 'styled-components'
import styledTheme from '../styles/theme'

import {
  ActionCableProvider,
  ActionCable,
} from '../components/utils/ActionCable'
import Badge from '../components/display/Badge'

const channelHash = {
  channel: 'UnreadConversationChannel',
}

export default class UnreadIndicator extends Component {
  constructor(props) {
    super(props)
    this.state = {
      unreadCount: props.unreadCount || 0,
    }
  }

  handleReceived = ({ unread_conversations_count }) => {
    this.setState({
      unreadCount: unread_conversations_count,
    })
  }

  renderIndicator() {
    const { unreadCount } = this.state
    if (unreadCount === 0) return null
    return <Badge warning>{unreadCount}</Badge>
  }

  render() {
    return (
      <ThemeProvider theme={styledTheme}>
        <span>
          <ActionCableProvider>
            <span>
              <ActionCable
                channel={channelHash}
                onReceived={this.handleReceived}
              />
              {this.renderIndicator()}
            </span>
          </ActionCableProvider>
        </span>
      </ThemeProvider>
    )
  }
}
